/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_JOURNAL_ENTRY,
  READ_JOURNAL_ENTRY_LIST,
  CREATE_JOURNAL_ENTRY,
} from 'domain/finance/journalEntry/useJournalEntryService';
import JournalEntryList from 'domain/finance/journalEntry/List';
import JournalEntryViewPage from 'domain/finance/journalEntry/Show';
import JournalEntryCreatePage from 'domain/finance/journalEntry/createupdate/Create';
import JournalEntryUpdatePage from 'domain/finance/journalEntry/createupdate/Update';
import JournalEntryReversePage from 'domain/finance/journalEntry/createupdate/Reverse';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import {
  getJournalEntryListUrl,
  getJournalEntryRouterPath,
  useJournalEntryRoute,
} from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import UploadJournalEntry from './uploadJournalEntry/UploadJournalEntry';

const JournalEntryRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createJournalEntryRoute,
    copyEntityRoute,
    reverseEntityRoute,
    updateRoute,
    uploadJournalEntryRoute,
    journalEntryByTransferRoute,
  } = useJournalEntryRoute();

  return (
    <ProtectedRouter basePath={getJournalEntryListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_JOURNAL_ENTRY_LIST}>
              <JournalEntryList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createJournalEntryRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_JOURNAL_ENTRY}>
              <JournalEntryCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={copyEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_JOURNAL_ENTRY}>
              <JournalEntryCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={updateRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_JOURNAL_ENTRY}>
              <JournalEntryUpdatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={uploadJournalEntryRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_JOURNAL_ENTRY}>
              <UploadJournalEntry />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={reverseEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_JOURNAL_ENTRY}>
              <JournalEntryReversePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_JOURNAL_ENTRY}>
              <JournalEntryViewPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={journalEntryByTransferRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_JOURNAL_ENTRY}>
              <JournalEntryViewPage shouldSearchByTransferId />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

JournalEntryRouter.getRouterPath = getJournalEntryRouterPath;

export default JournalEntryRouter;
